<template>
  <div class="bg-white rounded-tl-md rounded-tr-md">
    <div class="flex items-center tab shadow-border-b">
      <div
        class="px-6 py-3 relative cursor-pointer"
        :class="[tab.isActive ? 'text-neutral-700 font-medium active' : 'text-neutral-500']"
        v-for="tab in tabList"
        :key="tab.title"
        @click="selectTab(tab)"
      >
        {{ tab.title }}
      </div>
    </div>
    <div class="content">
      <component :is="selectedTab.content" :detail="partnerArmadaDetail" :bankData="bankData" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data: () => ({
    tabList: [
      {
        title: 'Info Partner',
        content: () => import(/* webpackChunkName: "InfoPartner" */ '@/views/Partner/InfoPartner'),
        isActive: false
      },
      {
        title: 'Kendaraan',
        content: () => import(/* webpackChunkName: "VehicleList" */ '@/views/Partner/VehicleList'),
        isActive: false
      }
    ],
    selectedTab: ''
  }),
  created() {
    this.selectTab(this.tabList[0])
    this.getPartnerInformartion()
  },
  computed: {
    ...mapGetters('armada', ['partnerArmadaDetail']),
    ...mapGetters('master', ['bankCodes']),
    ...mapGetters('auth', ['userData']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    bankData() {
      const bankName = this.bankCodes && this.bankCodes.filter(item => item.code === this.partnerArmadaDetail.bank_code)[0]
      const bankAccount = this.partnerArmadaDetail.bank_account
      return {
        name: bankName && bankName.name,
        account: bankAccount
      }
    }
  },
  methods: {
    ...mapActions('master', ['getBankCodes']),
    ...mapActions('armada', ['getPartnerArmadaDetail']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    selectTab(tab) {
      this.tabList.forEach(item => (item.isActive = false))
      const tabIndex = this.tabList.findIndex(item => item.title === tab.title)
      this.tabList[tabIndex].isActive = true
      this.selectedTab = tab
    },
    getPartnerInformartion() {
      this.visibleContent = false
      this.showLoading()
      this.getPartnerArmadaDetail({
        partnerId: this.partnerId,
        vehiclePartnerId: this.$route.params.id
      }).then(res => {
        this.visibleContent = true
        this.getBankCodeList()
      })
    },
    getBankCodeList() {
      this.getBankCodes()
        .then(() => {
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.tab {
  .active {
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
